import { useTranslate } from "@/hooks/use-translate/useTranslate";
import { useMemo } from "react";

const QuesntionsHeader = () => {
  const translate = useTranslate();
  const headers = useMemo(() => {
    return [
      {
        name: "Nº",
        widthClasses: "min-w-[150px]",
      },
      {
        name: "actionToDo",
        widthClasses: "min-w-[150px]",
      },
      {
        name: "images",
        widthClasses: "min-w-[150px]",
      },
      {
        name: "",
        widthClasses: "",
      },
    ];
  }, []);

  return (
    <tr className="font-[IberiaTextBold]">
      {headers.map((header, index) => (
        <th
          key={`th-${index}`}
          className={
            index === headers.length - 1
              ? `right-header ${header.widthClasses}`
              : `central-header ${header.widthClasses}`
          }
        >
          {translate(header.name)}
        </th>
      ))}
    </tr>
  );
};

export default QuesntionsHeader;
